import { render, staticRenderFns } from "./RegisterReader.vue?vue&type=template&id=2c124532&"
import script from "./RegisterReader.vue?vue&type=script&lang=js&"
export * from "./RegisterReader.vue?vue&type=script&lang=js&"
import style0 from "./RegisterReader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports